import MeetingNotice from '@components/ShareholderLetter/MeetingNotice';

export default function Page() {
    return <MeetingNotice />;
}
